import classNames from 'classnames'
import { bool, node, number, oneOfType, string } from 'prop-types'
import { Link } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'

import { makeUrlTo } from 'utils'

import CardComponent from './components/CardComponent'

import './index.scss'

function CreatorCard(props) {
  const {
    isPublic,
    className,
    id,
    highlight,
    onClick,
    data,
    groupId,
    provider,
    shouldEnableCreatorClick = false,
    onSeeVideos,
    index,
    title,
    ...rest
  } = props

  if (isPublic && !shouldEnableCreatorClick) {
    return (
      <div className="CreatorCard">
        <CardComponent {...props} />
      </div>
    )
  }

  if (onClick) {
    return (
      <div onClick={() => onClick(data)} className={classNames('CreatorCard', className)} {...rest}>
        <CardComponent {...props} />
      </div>
    )
  }

  const baseUrl = makeUrlTo.creator({ groupId, provider, creatorId: id })
  const to = baseUrl

  return !highlight ? (
    <Link target={'_self'} to={to} className={classNames('CreatorCard', className)}>
      <CardComponent {...props} />
      {onSeeVideos && (
        <Button
          onClick={e => onSeeVideos(e, id, groupId, provider, index, title)}
          className="CreatorCard-seeVideos-btn"
          variation="primary"
          appearance="outline"
        >
          See videos
        </Button>
      )}
    </Link>
  ) : (
    <div className={classNames('CreatorCard', className)}>
      <CardComponent {...props} />
    </div>
  )
}

CreatorCard.propTypes = {
  title: string,
  country: string,
  thumbnail: string,
  provider: string,
  followers: number,
  engagement: oneOfType([number, string]),
  views: oneOfType([number, string]),
  isBrand: bool,
  titleComponent: node,
}

CreatorCard.displayName = 'CreatorCard'

export default CreatorCard
